import { ref, onUnmounted, unref, computed } from '@vue/composition-api';

export default function useCountdown({ onComplete } = {}) {
  let timerId;

  const count = ref(0);
  const isCounting = ref(false);
  const isStarted = ref(false);
  const isStopped = computed(() => !unref(isCounting));
  const isExpired = computed(() => unref(isStarted) && unref(count) < 1);

  const stop = () => {
    isCounting.value = false;
    window.clearTimeout(timerId);
  };

  const start = (seconds) => {
    stop();
    count.value = seconds;
    isStarted.value = true;
    isCounting.value = true;

    timerId = window.setInterval(() => {
      count.value -= 1;
      if (unref(count) < 1) {
        stop();
        onComplete?.();
      }
    }, 1000);
  };

  onUnmounted(() => {
    stop();
  });

  return {
    count: computed(() => unref(count)),
    isStarted: computed(() => unref(isStarted)),
    isCounting: computed(() => unref(isCounting)),
    isStopped: computed(() => unref(isStopped)),
    isExpired: computed(() => unref(isExpired)),
    start,
    stop,
  };
}
